(function () {
  if (window.riwayatAccordionInitialized) return;
  window.riwayatAccordionInitialized = true;

  document.querySelectorAll('[data-riwayat-accordion]').forEach(function (group) {
    var allowMultiple = group.getAttribute('data-allow-multiple') === 'true';
    var rows = Array.prototype.slice.call(group.querySelectorAll('[data-riwayat-accordion-trigger]'));

    rows.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var row = trigger.closest('[data-riwayat-accordion-row]');
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        if (!allowMultiple) {
          rows.forEach(function (t) {
            if (t !== trigger) {
              t.setAttribute('aria-expanded', 'false');
            }
          });
        }

        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  });
})();
